<template>
  <v-dialog v-model="show">
    <v-card class="mt-2">
      <v-card-title primary-title style="padding-left:8px;padding-bottom:8px">
        <span class="headline mb-0">{{$t('B0300.titles[4]')}}</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="save" small>{{$t('app.buttons.save')}}</v-btn>
        <v-btn small>{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs3>
              <v-text-field :label="$t('app.labels.lotNo')" clearable v-model="query.lotNo"/>
            </v-flex>
            <v-flex xs3>
              <v-text-field :label="$t('app.labels.skuCode')" clearable v-model="query.itemNo"/>
            </v-flex>
            <v-flex xs3>
              <v-text-field
                :label="$t('app.labels.productCode')"
                clearable
                v-model="query.itemName"
              />
            </v-flex>
            <v-flex xs3>
              <v-text-field :label="$t('app.labels.unit')" clearable v-model="query.unit"/>
            </v-flex>
            <v-flex xs3>
              <v-text-field
                :label="$t('app.labels.invoice.item.unitPrice')"
                clearable
                type="number"
                v-model="query.unitPrice"
              />
            </v-flex>
            <v-flex xs3>
              <v-text-field :label="$t('app.labels.qty')" type="number" v-model="query.qty"/>
            </v-flex>
            <v-flex xs3>
              <v-text-field
                :label="$t('app.labels.price')"
                clearable
                type="number"
                v-model="query.price"
              />
            </v-flex>
            <v-flex xs3>
              <v-text-field
                :label="$t('app.labels.invoice.item.origin')"
                clearable
                v-model="query.origin"
              />
            </v-flex>
            <v-flex xs3>
              <v-text-field
                :label="$t('app.labels.division')"
                clearable
                disabled
                v-model="query.division"
              />
            </v-flex>
            <v-flex xs3>
              <v-text-field
                :label="$t('B0300.labels.incoterm')"
                clearable
                v-model="query.incoterm"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      query: {
        paid: 0,
        division: '無償',
        addtional: false
      },
      show: false
    }
  },
  methods: {
    popup() {
      this.show = true
    },
    save() {
      this.query.addtional = true
      this.$emit('add', this.query)
      this.show = false
    }
  }
}
</script>
